import React from "react";
import ReactDOM from "react-dom";
import setDefaultOptions from "date-fns/setDefaultOptions";
import { da } from "date-fns/locale";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import GlobalState from "./context/global/GlobalState";

// Set global locale:
setDefaultOptions({ locale: da });

ReactDOM.render(
  <GlobalState>
    <App />
  </GlobalState>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
